import type { CctvListData, CctvListItem } from '@/domains/traffic-monitoring/types/cctv.types';
import { APIS, URLS } from '@/shared/config/urls';
import type { ApiResponse } from '@/shared/types/abstract-api-response';
import { request } from '@/shared/utils/request';

// [GET] CCTV List - PSC_MA0303001_BE_001
// Backend already resolves each camera's stream URL (hls_low_stream_url /
// hls_high_stream_url); the frontend never computes an edge/port/URL itself.
export const fetchCctvList = (filterParams = ''): Promise<ApiResponse<CctvListData>> => {
  const url = `${URLS.BACK_DSH}${APIS.cctvList(filterParams)}`;
  return request.get(url);
};

// hls_low_stream_url looks like `{domain}/hls/cctv-group-{a-e}/site_{id}/index.m3u8`.
// The group letter isn't a separate DB column - it's embedded in the path -
// so pages/groups get parsed out of the URL rather than requested from the backend.
export const getCctvGroup = (cctv: CctvListItem): string | null => {
  const group = cctv.hls_low_stream_url?.match(/cctv-group-([a-e])/i)?.[1];
  return group ? group.toLowerCase() : null;
};

export const cctvStreamService = {
  getHlsUrl: (cctv: CctvListItem) => cctv.hls_low_stream_url,
  getHighResUrl: (cctv: CctvListItem) => cctv.hls_high_stream_url ?? cctv.hls_low_stream_url,
  getStreamLabel: (cctv: CctvListItem) => cctv.name || `cctv_${cctv.cctv_id}`,
};
